import { readAsList } from '@onevision-resources/json-api-parser';
import { apiClient } from 'core/api';
import { AppThunk } from 'core/redux';
import GroupRules from 'core/redux/reducers/partnerGroupRules';
import { getNextPage } from 'core/redux/reducers/helpers';
import PartnerGroups from 'core/redux/reducers/partnerGroups';
import RuleValues from 'core/redux/reducers/partnerGroupRuleValues';
import { ListReducerState } from 'core/redux/reducers/types';

export const fetchPartnerRuleValues =
  (options: Partial<ListReducerState> = {}, listId?: string): AppThunk =>
  async (dispatch, getState) => {
    const state = getState();
    const listState = RuleValues.selectors.selectList(state, listId || '');
    const nextPage = getNextPage(options.page, listState);

    const limit = options.perPage || listState.perPage;
    const offset = limit * (nextPage - 1);

    delete options.perPage;
    const apiResponse = await apiClient.getRuleValues({
      include: listState.include,
      search: listState.search,
      ...options,
      page: {
        limit,
        offset,
      },
    });

    const {
      meta: { page, defaultPage, ...meta },
      entities,
    } = readAsList(apiResponse.data);

    const { PartnerGroupRuleValue, PartnerGroup, PartnerGroupRule } =
      entities;

    if (PartnerGroupRuleValue) {
      dispatch(
        RuleValues.actions.batch([
          RuleValues.actions.updateList(
            {
              ...meta,
              ids: PartnerGroupRuleValue.map((e) => e.id),
              page: page ? page.offset / page.limit + 1 : nextPage,
              perPage: page ? +page.limit : listState.perPage,
              lastPage: Math.ceil(
                meta.totalCount / (page ? page.limit : listState.perPage),
              ),
            },
            listId,
          ),
          RuleValues.actions.upsertMany(PartnerGroupRuleValue),
        ]),
      );
    }

    if (PartnerGroup) {
      dispatch(PartnerGroups.actions.upsertMany(PartnerGroup));
    }
    if (PartnerGroupRule) {
      dispatch(GroupRules.actions.upsertMany(PartnerGroupRule));
    }
  };
